// hooks/useIsPWA.ts
import { useState, useEffect } from 'react';

// Extender el tipo Navigator para incluir la propiedad standalone de iOS
declare global {
  interface Navigator {
    standalone?: boolean;
  }
}

export const useIsPWA = () => {
  const [isPWA, setIsPWA] = useState(false);
  
  useEffect(() => {
    const checkPWA = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const isInWebAppiOS = window.navigator.standalone === true;
      setIsPWA(isStandalone || isInWebAppiOS);
    };
    
    checkPWA();
    
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    mediaQuery.addEventListener('change', checkPWA);
    
    return () => mediaQuery.removeEventListener('change', checkPWA);
  }, []);
  
  return isPWA;
};